/* eslint-disable no-nested-ternary */
import { SxProps, Theme, alpha, styled, useTheme } from '@mui/material/styles';
import { UserStatus } from 'src/@types/user-status';
import BadgeStatus from '../badge-status';
import Iconify from '../iconify';
import { CustomAvatar, CustomAvatarProps } from './index';

const ChannelAvatar = styled(CustomAvatar)<{
  conditions: {
    small?: boolean;
    active: boolean;
  };
}>(({ theme, conditions: { small, active } }) => ({
  '& .MuiAvatar-root': {
    width: 32,
    height: 32,
    fontSize: 18,
    color: theme.palette.text.secondary,
    backgroundColor: alpha(theme.palette.grey[500], 0.16),
    border: 'none',
    '& .MuiAvatar-img': {
      width: 'unset',
      height: 'unset',
    },
    ...(small && {
      width: 24,
      height: 24,
      fontSize: 14,
    }),
    ...(active && {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.16),
      border: `1px solid ${theme.palette.primary.main}`,
    }),
  },
}));

interface Props extends CustomAvatarProps {
  name: string;
  src?: string | undefined;
  icon: string;
  online?: boolean;
  variant?: 'circular' | 'rounded' | 'square';
  isChannelActive?: boolean;
  active: boolean;
  isBig?: boolean;
  sx?: SxProps<Theme>;
}

const NavbarCustomAvatar = ({
  name,
  src,
  icon,
  online,
  variant = 'rounded',
  active,
  isBig = false,
  sx,
  ...rest
}: Props) => {
  const theme = useTheme();

  const badge = online ? (
    <BadgeStatus status={UserStatus.ONLINE} />
  ) : (
    <Iconify
      sx={{ ...sx }}
      icon={icon}
      color={theme.palette.background.default}
      bgcolor={
        active ? theme.palette.primary.main : theme.palette.text.disabled
      }
      width={isBig ? 18 : 16}
      height={isBig ? 18 : 16}
      borderRadius={1}
      padding={theme.spacing(0.25)}
      marginTop={theme.spacing(0.25)}
      marginLeft={theme.spacing(0.25)}
    />
  );

  return (
    <ChannelAvatar
      name={name}
      src={src}
      BadgeProps={{
        badgeContent: badge,
      }}
      conditions={{
        small: !isBig,
        active,
      }}
      variant={variant}
      {...rest}
    />
  );
};

export default NavbarCustomAvatar;
